<script setup lang="ts">
import { ref } from 'vue';
import Icon from './Icon.vue';
defineProps<{ title: string; count: number; latest?: string }>();
const open = ref(false);
</script>

<template>
  <section class="connector-history">
    <div class="section-heading history-heading">
      <button type="button" class="history-toggle" :aria-expanded="open" @click="open = !open">
        <Icon name="ChevronDown" :class="{ expanded: open }" /><span><strong>{{ title }}（{{ count }}）</strong><small v-if="latest">{{ latest }}</small></span>
      </button>
      <slot name="actions" />
    </div>
    <div v-show="open"><slot /></div>
  </section>
</template>

<style scoped>
.connector-history { margin-top: 24px; }
.history-heading { gap: 12px; }
.history-toggle { display: flex; align-items: center; gap: 10px; text-align: left; border: 0; background: none; color: inherit; cursor: pointer; padding: 8px 0; min-width: 0; font: inherit; }
.history-toggle span { min-width: 0; }
.history-toggle strong { display: block; font-size: 18px; }
.history-toggle small { display: block; color: var(--muted); margin-top: 4px; overflow-wrap: anywhere; }
.history-toggle :deep(svg) { flex-shrink: 0; transform: rotate(-90deg); transition: transform .2s; }
.history-toggle :deep(svg.expanded) { transform: rotate(0); }
.history-toggle:focus-visible { outline: 2px solid var(--accent, #7852cf); outline-offset: 4px; border-radius: 4px; }
@media (prefers-reduced-motion: reduce) { .history-toggle :deep(svg) { transition: none; } }
</style>
